import { observer } from 'src/utils/mobx-react';
import { ActionDropdown } from 'src/components/ActionDropdown/ActionDropdown';
import { SelectWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components/SelectWrapper';
import config from 'src/config';
import React from 'react';
import { LiabilitiesFiltersProps } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';

type CountryFilterPropsType = Pick<LiabilitiesFiltersProps, 'onChange'> & {
    country?: string | null;
};

export const CountryFilter = observer('CountryFilter', ({ country, onChange }: CountryFilterPropsType) => {
    const handleChange = (value: unknown): void => onChange('country', value);
    const title = 'Country';

    return (
        <div className='col-2'>
            <SelectWrapper label={title}>
                <ActionDropdown
                    label={title}
                    className='dropdown-select-form'
                    options={config.countries}
                    value={country}
                    searchable
                    clearable
                    ignoreCase
                    onChange={handleChange}
                    isShorten={false}
                />
            </SelectWrapper>
        </div>
    );
});
